<template>
    <div>
        <b-form-group label-for="dias" class="mt-2">
            <b-form-group class="form-check form-check-inline">
                <b-form-checkbox v-model="competitionActivities" :value="1" :disabled="disabled">
                    Existe concurrencia EE-Cliente
                </b-form-checkbox>
            </b-form-group>
        </b-form-group>
    </div>
</template>

<script>
import {BFormGroup, BFormCheckbox} from 'bootstrap-vue'

export default {
    components: {
        BFormGroup,
        BFormCheckbox,
    },
    props: {
        competitionActivities: {
            type: Number,
            default: 1
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            localCompetitionActivities: this.competitionActivities,
        }
    },
    watch: {
        competitionActivities(newVal) {
            this.localCompetitionActivities = newVal
            this.$emit('update', { competition_activities: this.localCompetitionActivities })
        },
    },
}
</script>
